export const VITAL_SIGN_DATE_VALIDATOR = 'vital-sign-date-validator';
async function vitalSignRegisterDateValidator(value) {
    let message = '';
    let valid = false;
    if (value) {
        const today = new Date();
        const vitalSignDate = new Date(value);
        valid = vitalSignDate <= today;
        if (!valid) {
            message = 'message.start-date-greater-current-date';
        }
    }
    return [{
            message: message,
            name: VITAL_SIGN_DATE_VALIDATOR,
            valid: valid
        }];
}
export default vitalSignRegisterDateValidator;
//# sourceMappingURL=vital-sign-register-date-validator.js.map